import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL, PRICE, ANCHOR_PRICE, TOTAL_VALUE, SAVINGS } from '../lib/config';
const volumes = ['Tomo 1 — El Salto de Valor', 'Tomo 2 — El Embudo de WhatsApp Gold ⭐', 'Tomo 3 — Protocolo Anti-Ghosting', 'Tomo 4 — Ingeniería de la Recomendación', 'Tomo 5 — Finanzas de Guerra para Creativos', 'Tomo 6 — Tráfico Directo Premium'];
const bonuses = ['Bono 1 — Pack de Respuestas Anti-Regateo', 'Bono 2 — Guía Express de Primera Respuesta por WhatsApp', 'Bono 3 — Cómo Subir Tus Precios Sin Perder Clientas', 'Bono 4 — Checklist de Perfil Premium en Instagram', 'Bono 5 — Plantilla de Seguimiento de Leads Nupciales'];
export function Pricing() {
  return <section id="pricing" className="w-full bg-ivory py-16 sm:py-24" data-id="element-168" data-mp="3h6bks0ubzvzn">
      <div className="mx-auto max-w-3xl px-5" data-id="element-169" data-mp="3c8tc8bk87is6">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-170" data-mp="3c7s3weulhae5">
          Instala el sistema completo hoy
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-171" data-mp="4t5mjfll1dzm" />

        <div className="mt-12 border border-gold bg-white shadow-card" data-id="element-172" data-mp="4rb365pyltxn">
          <div className="border-b border-gold-soft/70 bg-gold-tint px-7 py-8 text-center" data-id="element-173" data-mp="9tjwj36quy0a">
            <h3 className="font-serif text-2xl sm:text-3xl text-ink" data-id="element-174" data-mp="eqabfn6tbnk4">
              Wedding Pro OS™ — Edición Completa
            </h3>
            <p className="mt-3 text-sm text-ink-soft" data-id="element-175" data-mp="3d6uqko3y8i4s">
              Todo lo que necesitas para dejar de improvisar y empezar a operar como agencia.
            </p>
          </div>

          <div className="grid gap-x-10 gap-y-3 px-7 py-9 sm:grid-cols-2" data-id="element-176" data-mp="3n5kb6on8cgoq">
            {volumes.map(item => <p key={item} className="flex items-start gap-3 text-[15px] text-ink" data-id="element-177" data-mp="3rzy7qudmotuz">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-178" data-mp="2uhy3p5avsrwl" />
                {item}
              </p>)}
            {bonuses.map(item => <p key={item} className="flex items-start gap-3 text-[15px] text-ink-soft" data-id="element-179" data-mp="2mi1l7ianzzbz">
                <GiftIcon className="mt-1 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-180" data-mp="316oaocu0a7gx" />
                {item}
              </p>)}
          </div>

          <div className="border-t border-gold-soft/70 px-7 py-9 text-center" data-id="element-181" data-mp="28hh18it0jxgw">
            <p className="text-[11px] uppercase tracking-[0.24em] text-ink-muted" data-id="element-182" data-mp="23ixgglq5orq4">
              Valor total: {TOTAL_VALUE}
            </p>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-183" data-mp="2ih7w4llhkehi">
              Precio regular: <s data-id="element-184" data-mp="2dhd9wvcnod2s">{ANCHOR_PRICE} USD</s>
            </p>
            <p className="mt-2 flex items-end justify-center gap-2" data-id="element-185" data-mp="2dfsdt1ap0m2t">
              <span className="font-serif text-6xl leading-none text-ink" data-id="element-186" data-mp="3tuaftpivtk5w">{PRICE}</span>
              <span className="pb-2 text-xs uppercase tracking-[0.2em] text-ink-muted" data-id="element-187" data-mp="3ox1szbmsgryb">
                USD
              </span>
            </p>
            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[11px] uppercase tracking-[0.16em]" data-id="element-188" data-mp="92jix96sxv2">
              <li className="bg-ink px-3 py-1.5 text-gold" data-id="element-189" data-mp="3nfczipwlep6d">Ahorras {SAVINGS}</li>
              <li className="border border-gold-soft px-3 py-1.5 text-ink-soft" data-id="element-190" data-mp="3nhfyw0jmxunr">
                Pago único
              </li>
              <li className="border border-gold-soft px-3 py-1.5 text-ink-soft" data-id="element-191" data-mp="j0d6j3bskqho">
                Acceso de por vida
              </li>
            </ul>

            <p className="mt-8 text-xs italic text-ink-muted" data-id="element-192" data-mp="nz6i2q7iq7f7">
              El cobro se realiza en tu moneda local.
            </p>

            <div className="mt-4" data-id="element-193" data-mp="e9wr5doeuuso">
              <CtaButton href={CHECKOUT_URL} className="w-full sm:w-auto" data-id="element-194" data-mp="e93k0blji3a0">
                Sí, quiero el Wedding Pro OS
              </CtaButton>
            </div>

            <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-195" data-mp="16q7i7hkdk90c">
              <li className="inline-flex items-center gap-2" data-id="element-196" data-mp="3f93dxu3zv9kb">
                <LockIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-197" data-mp="3a7w47piak0b0" />
                Pago seguro
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-198" data-mp="359uonek2qj4a">
                <ZapIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-199" data-mp="3189374th4wih" />
                Descarga inmediata
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-200" data-mp="1s45vkrqogvb">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-201" data-mp="3syf1v2hw6rfs" />
                Garantía de 7 días
              </li>
            </ul>

            <p className="mx-auto mt-8 max-w-md font-serif text-lg italic leading-snug text-gold-dark" data-id="element-202" data-mp="3k5k4euyo200k">
              Cuesta menos que lo que pierdes en UNA sola boda cobrada a &ldquo;precio de
              amiga&rdquo;.
            </p>
          </div>
        </div>
      </div>
    </section>;
}